import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { catchError, map, Observable, of, tap, throwError } from 'rxjs';

import { MetaService } from '../services/meta.service';
import { PageBuilderService } from '../services/page-builder.service';
import { PageLayoutService } from '../services/page-resolver.service';
import { PageResolverResopnse } from '../types/page-resolver-response.type';

export const fallbackPageResolver: ResolveFn<PageResolverResopnse | null> = (
    route: ActivatedRouteSnapshot,
): Observable<PageResolverResopnse | null> => {
    const pageLayoutService = inject(PageLayoutService);
    const pageBuilderService = inject(PageBuilderService);
    const metaService = inject(MetaService);

    pageBuilderService.pageData.next(null);

    return pageLayoutService.resolvePageLayout(route).pipe(
        map((response) => {
            if (response?.pageDataResponse?.body?.data?.page_type === 'not-found-page') {
                return null;
            }

            return response;
        }),
        tap((response) => {
            if (response) {
                metaService.updateMetaTags(response, route);
            }
        }),
        catchError((error) => {
            if (error.status === 404) {
                return of(null);
            }

            return throwError(() => error);
        }),
    );
};
